/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Status = "ACTIVE" | "COMPLETED" | "CREATED" | "DEACTIVE" | "DELETED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ActiveCompany_activeCompany$ref: FragmentReference;
export type ActiveCompany_activeCompany = {|
  +name: string,
  +id: string,
  +state: ?$ReadOnlyArray<{|
    +name: string,
    +attr: string,
    +value: string,
  |}>,
  +strategies: $ReadOnlyArray<{|
    +status: Status,
    +id: string,
    +path: ?string,
    +isCoaching: ?boolean,
    +employees: $ReadOnlyArray<{|
      +id: string
    |}>,
    +stepGoals: $ReadOnlyArray<{|
      +name: string,
      +path: ?string,
      +status: Status,
      +index: number,
      +id: string,
      +actionPlans: $ReadOnlyArray<{|
        +path: ?string,
        +name: string,
        +status: Status,
        +index: number,
        +id: string,
      |}>,
    |}>,
    +name: string,
    +bigGoals: $ReadOnlyArray<{|
      +id: string,
      +index: number,
      +path: ?string,
      +name: string,
      +status: Status,
      +stepGoals: $ReadOnlyArray<{|
        +name: string,
        +path: ?string,
        +status: Status,
        +index: number,
        +id: string,
        +actionPlans: $ReadOnlyArray<{|
          +path: ?string,
          +name: string,
          +status: Status,
          +index: number,
          +id: string,
        |}>,
      |}>,
    |}>,
  |}>,
  +$refType: ActiveCompany_activeCompany$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "index",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "stepGoals",
  "storageKey": null,
  "args": null,
  "concreteType": "StepGoal",
  "plural": true,
  "selections": [
    v0,
    v3,
    v2,
    v4,
    v1,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actionPlans",
      "storageKey": null,
      "args": null,
      "concreteType": "ActionPlan",
      "plural": true,
      "selections": [
        v3,
        v0,
        v2,
        v4,
        v1
      ]
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "ActiveCompany_activeCompany",
  "type": "Company",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    v1,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "state",
      "storageKey": null,
      "args": null,
      "concreteType": "State",
      "plural": true,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "attr",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "strategies",
      "storageKey": null,
      "args": null,
      "concreteType": "Strategy",
      "plural": true,
      "selections": [
        v2,
        v1,
        v3,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isCoaching",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "employees",
          "storageKey": null,
          "args": null,
          "concreteType": "Employee",
          "plural": true,
          "selections": [
            v1
          ]
        },
        v5,
        v0,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "bigGoals",
          "storageKey": null,
          "args": null,
          "concreteType": "BigGoal",
          "plural": true,
          "selections": [
            v1,
            v4,
            v3,
            v0,
            v2,
            v5
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '58cc476748c7216e2ccfab72cebc49b7';
module.exports = node;
